import React from 'react';
import {useState, useEffect, useMemo} from 'react';
import CaseSheetLayout from '../casesheet/casesheet';
import BasicInfo from './basicInfo/basicInfo';
import ExaminationInfo from './examinationInfo/examinationInfo';
import PatientHistory from './patientHistory/patientHistory';
import DeviceData from './deviceData/deviceData';
import Intrapartum from './intrapartumData/intrapartum';
import DeliveryInfo from './deliveryInfo/deliveryInfo';
import ChildbirthChecklist from './childbirthChecklist/childbirthChecklist';
import PostpartumData from './postpartumData/postpartumData';
import Form from './form/form';
import DischargeInformation from './dischargeInformation/dischargeInformation';
import ReferralDetails from './referralDetails/referralDetails' 
import AlertDetails from './alertDetails/alertDetails';
import PatientInformaton from '../basic/patientInformaton'
import DeviceInformation from '../basic/deviceData'
import NoData from '../common/NoData';
import './viewLayout.scss';
import OsiGraph from '../osi/osiGraph';
import Spo2Graph from '../osi/spo2Graph';
import {useNavigate, useLocation, useParams } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import { isJson, getReadableTime, sortDataByLatestTimestamp, handleReload } from '../../utils/converter';
import urls from '../../utils/url';
import { isTabularViewPlace } from '../../utils/graphPlaceIds';
import Cookie from 'js-cookie';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import NavamPatientInfoComponent from '../navam/navamPatientInfoComponent'
import NavamBillirubinComponent from '../navam/navamBillirubinComponent';
import NavamNewbornVitals from '../navam/navamNewbornVitals';
import Loading from '../common/loading';


// import L1CasesheetLayout from '../Case-sheet/l1Casesheet';
// import L2CasesheetLayout from '../Case-sheet/l2Casesheet';
// import L3CasesheetLayout from '../Case-sheet/l3Casesheet';



const ViewLayout = () => {

  const cookie = Cookie.get('access_token')
  const cookieData = Cookie.get('data');
  const hospitalDetailCookie = JSON.parse(Cookie.get('hospital_detail') || '{}');
  const isTabularViewEnabled = isTabularViewPlace(hospitalDetailCookie?.hospitalID);
  const navigate =  useNavigate();
  const {patientID} = useParams();
  const location = useLocation();

  // Initialize activeIndex from sessionStorage
  const [activeIndex, setActiveIndex] = useState(() => {
    const savedIndex = sessionStorage.getItem('viewLayoutActiveIndex');
    return savedIndex ? parseInt(savedIndex) : 0;
  });

  // Save activeIndex to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('viewLayoutActiveIndex', activeIndex.toString());
  }, [activeIndex]);

  // const [selectType, setSelectType] = useState('mother');
  const [caseSheetOpen, setCaseSheetOpen] = useState(false);
  const [data]  = useState(location.state);
  const [accountType, setAccountType] = useState('');
  const [selectedSubTab, setSelectedSubTab] = useState('NST');
  const [keyarCMData, setKeyarCMData] = useState([])
  const [keyarDTData, setKeyarDTData] = useState([])
  const [keyarEchoData, setKeyarEchoData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [activeTabIndex, setActiveTabIndex] =  useState(() => {
  const savedTabIndex = sessionStorage.getItem('viewLayoutActiveTabIndex');
  return savedTabIndex ? parseInt(savedTabIndex) : 0;
});
  const [otherDetail, setOtherDetail] = useState([])
  const [basicDetail, setBasicDetail] = useState([])
  const [numberOfFetus, setNumberOfFetus] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [deviceData, setDeviceData] = useState()
  const [placeDetail, setPlaceDetail] = useState([]);
  // const [casesheetTab, setCasesheetTab] = useState('l1-casesheet');
  const [ isMrn, setIsMrn] = useState(true); // For Malaysia Specific Requirement

  const displayPatientIdentifier =
  data?.mrn && data.mrn !== "NA" && data.mrn.trim() !== ""
    ? data.mrn
    : data?.patient_id;

  useEffect(() => {
    // Check if data is not available in the location state
    if (!data) {
      navigate('/');
    }
  }, [ data, navigate]);

  useEffect(() => {

    if (cookieData) {
        const parsedData = JSON.parse(cookieData);
        const account_type = parsedData.account_type;
        const algorithmEnabled = parsedData.fetal_distress_algorithm;
        //console.log(algorithmEnabled)

        setIsMrn(algorithmEnabled);
        setAccountType(account_type); 
    } 
  },[cookieData, accountType])

  // const casesheets = {
  //   'L1 Casesheet' : 'l1-casesheet',
  //   'L2 Casesheet' : 'l2-casesheet',
  //   'L3 Casesheet' : 'l3-casesheet',
  // }
  
  const components = [BasicInfo, ExaminationInfo, PatientHistory,  DeviceData, Intrapartum, DeliveryInfo, PostpartumData ,ChildbirthChecklist, Form, DischargeInformation, AlertDetails, ReferralDetails];
  const ActiveComponent = components[activeIndex];
  const componentItems = ['Basic Information', 'Examination Information','Patient History','Device Data','Intrapartum Data','Delivery Information','Postpartum Data','Childbirth Checklist','Consent Forms','Discharge Information', 'Alert Details','Referral Details'];
  const activeComponentName = componentItems[activeIndex]

  useEffect(() => {
    // console.log(data?.alertindex)
    if(data?.alertIndex){
      // If User is clicking on alert arrow then alerts section will be shown directly
      setActiveIndex(data?.alertIndex);   
    }
  }, [data]);
 
  const osiComponents = [OsiGraph, Spo2Graph]
  const osiComponentItems = ['OSI','SPO2'];
  const ActiveOSIComponents = osiComponents[activeIndex];
  const activeOSIComponentName = osiComponentItems[activeIndex] // For Breadcrumb tail

  // For Basic Version
  const basicComponents = [PatientInformaton, DeviceInformation];
  const basicComponentItems = [
    {
      text: 'Patient Information',
      active_image: '/patient-info-icon.svg',
      inactive_image: '/inactive-patient-info.svg',
    },
    {
      text: 'Device Data',
      active_image: '/active-device-data.svg',
      inactive_image: '/inactive-device-data-icon.svg',
    },
  ];
  const ActiveBasicComponents = basicComponents[activeIndex];

 // For NAVAM
  const navamComponents = [NavamPatientInfoComponent, NavamNewbornVitals, NavamBillirubinComponent];
  const ActiveNavamComponent = navamComponents[activeIndex];
  const navamComponentItems = [
    {
      text: 'Patient Information',
      active_image: '/patient-info-icon.svg',
      inactive_image: '/inactive-patient-info.svg',
    },
    {
      text: 'Newborn Vitals',
      active_image: '/active-newborn-vitals.svg',
      inactive_image: '/inactive-newborn-vitals.svg',
    },
    {
      text: 'Bilirubin Value',
      active_image: '/active-device-data.svg',
      inactive_image: '/inactive-device-data-icon.svg',
    },
  ];
  const ActiveNavamComponentName = navamComponentItems[activeIndex]
  
  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

 useEffect(() => {
  sessionStorage.setItem('viewLayoutActiveTabIndex', activeTabIndex.toString());
}, [activeTabIndex]);

useEffect(() => {
  setActiveTabIndex(0);
  sessionStorage.setItem('viewLayoutActiveTabIndex', '0');
}, [patientID]);


  const showGraph = (index, data) => {
    setDeviceData(data);
    setActiveTabIndex(index);
    setIsPlaying(false);
    sessionStorage.setItem('viewLayoutActiveTabIndex', index.toString());
  }

  useEffect(() => {
    if(accountType && ['Basic'].includes(accountType)){
      fetchDeviceData();
    }
 
  },[accountType]);


// Merging data of Keyar Echo, Keyar CM and Keyar DT
const mergedDeviceData = useMemo(() => [
  ...(keyarDTData || []).map((device) => ({
    data: device,
    data_time: device.data_time,
    device_name: 'Keyar DT',
    active_image: '/active-doppler.svg',
    inactive_image: '/inactive-doppler.svg',
  })),
  ...(keyarCMData || []).map((device) => ({
    data: device,
    data_time: device.data_time,
    device_name: 'Keyar CM',
    active_image: '/active-cm-patch.svg',
    inactive_image: '/inactive-cm-patch.svg',
  })),
].sort((a, b) => new Date(b.data_time) - new Date(a.data_time)), [
  keyarDTData,
  keyarCMData,
]);

useEffect(() => {
  if (mergedDeviceData.length > 0) {
    const savedTabIndex = sessionStorage.getItem('viewLayoutActiveTabIndex');
    const indexToUse = savedTabIndex ? parseInt(savedTabIndex) : 0;
    
    // Make sure the index is valid for the current data
    const validIndex = indexToUse < mergedDeviceData.length ? indexToUse : 0;
    
    setDeviceData(mergedDeviceData[validIndex]);
    setActiveTabIndex(validIndex);
  }
}, [mergedDeviceData]);

  const fetchDeviceData = async () => {
      setLoading(true);
      await axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=keyar_data,basic_detail,pa_pv_examination,place_details,obstetric_histories&`,
      {
        headers: {
        'Request-ID': 'allow|me', 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookie}`
        }
      }).then((res) => {     
        if(res.data){
            const jsonData = isJson(res.data)
            const keyar_data = jsonData.response[0]?.keyar_data

           // console.log(res.data.response[0].obstetric_histories[0].no_of_children)

            const sortedKeyarData = sortDataByLatestTimestamp(keyar_data)

            let cm_data = []
            let dt_data = []
            let echo_data = []
            let undefined_data = []

            if (Object.keys(sortedKeyarData || []).length > 0){
              keyar_data?.forEach(item => {

                if (!item.params == undefined || !item.params == ''){
                  const ucData = item.params.find(data => data.param_type == 'uc');
                  if (ucData) {
                    const ucTimestamps = Object.keys(ucData.data_set || [])?.map(Number)?.sort((a, b) => a - b)
                    var timestampDifference = ucTimestamps[1] - ucTimestamps[0]
                  }
                
                  if ( ucData && ucData.serial_number.includes("JKEC")) {
                      echo_data.push(item);
                  } else if (ucData && (ucData.serial_number.includes('JKDP') || ucData.serial_number.includes('eFM') || timestampDifference < 1100)) {
                      dt_data.push(item);
                  } else if (ucData && (ucData.serial_number.includes('JKKP') || (timestampDifference > 1100 && timestampDifference < 2200))) {
                    cm_data.push(item);
                  } else {
                    undefined_data.push([])
                  }
                }
                // Add more conditions here for other serial number checks
              });
            }
          
            setKeyarCMData(cm_data)
            setKeyarDTData(dt_data)
            setKeyarEchoData(echo_data)
            
            const patient_detail = jsonData.response[0].basic_detail;
            const patient_other_detail = jsonData.response[0].pa_pv_examination;
            const place_detail = jsonData.response[0].place_details;
            const number_of_fetus = jsonData?.response[0]?.obstetric_histories[0]?.no_of_children || 0;

            setNumberOfFetus(number_of_fetus);
            setBasicDetail(patient_detail);
            setOtherDetail(patient_other_detail);
            setPlaceDetail(place_detail);
            // setPatientDetail({
            //   name : `${patient_detail.name}`,
            //   age: `${patient_detail.age}`,
            //   patient_id: `${patient_detail.id}`,
            //   ges_period: `${patient_other_detail.gestation_period}`
            // })
            //const keyar_data = latest_keyar_data[latest_keyar_data.length-1]
            // setKeyarData(keyar_data)
            // setStartTime(latest_keyar_data[latest_keyar_data.length-1].data_time)
            
            setLoading(false);
        }
      }).catch((err) => {
        console.log("Graph API failed",err)
        setError(true)
        setLoading(false)
      })
  }

  const openCaseSheet= () => {
    setCaseSheetOpen(true);
  }
  
  
  const handleClick = (index) => {
    setActiveIndex(index);
  };

  const handleKeyDown = (e, activeIndex, componentsLength, osiComponentsLength) => {
    if(accountType && accountType.length > 0 && (accountType === 'Daksh SI' || accountType === 'Basic' || accountType === 'Navam')){
      if (e.key === 'ArrowUp') {
        setActiveIndex((activeIndex - 1 + osiComponentsLength) % osiComponentsLength);
      } else if (e.key === 'ArrowDown') {
        setActiveIndex((activeIndex + 1) % osiComponentsLength);
      } 
    }
    else {
      if (e.key === 'ArrowUp') {
        setActiveIndex((activeIndex - 1 + componentsLength) % componentsLength);
      } else if (e.key === 'ArrowDown') {
        setActiveIndex((activeIndex + 1) % componentsLength);
      } 
    }
  };
  
  useEffect(() => {
    const handleKeyDownEvent = (e) => {
      handleKeyDown(e, activeIndex, componentItems.length, osiComponentItems.length, basicComponentItems.length);
    };
    
    window.addEventListener('keydown', handleKeyDownEvent);
    return () => {
      window.removeEventListener('keydown', handleKeyDownEvent);
    };
  }, [activeIndex, componentItems.length, osiComponentItems.length, basicComponentItems.length]);


  // const handleTabChange = (e) => {
  //   setCasesheetTab(e.target.value);
  // };

  const handleClose= () => {
    sessionStorage.setItem('viewLayoutActiveIndex', '0');
    sessionStorage.setItem('viewLayoutActiveTabIndex', '0');
    setActiveIndex(0); // Optional: if component is still mounted before navigating
    navigate('/dashboard/report'); // Navigate back to reports
    // Restore scroll position after a short delay
    setTimeout(() => {
      const scrollY = sessionStorage.getItem('reportScrollPosition');
      if (scrollY) window.scrollTo(0, parseInt(scrollY, 10));
    }, 50);
  };

  // Handle clicking outside modal to close
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  // Handle Escape key to close modal
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [handleClose]);

  // Prevent background scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);


  //console.log(numberOfFetus, "Number of Fetus in viewlayout")
  return (
    <div className="view-layout-modal-overlay" onClick={handleOverlayClick}>
      <div className="view-layout-modal">
        
        {!accountType ? (
          // Show loading when accountType is not yet determined
          <div className='loading-div'>
            <Loading/>
          </div>
        ) : accountType && accountType.length > 0 && accountType === 'OSI' ?

            <div className='view-section'>
              <div className='view-file-header'>

                 <div className='patient-info-header'>
                    <img className = "back-arrow" src = "/back_arrow.svg" alt='Back Arrow' onClick = {() => handleClose()} />
                    <div className='update'>
                                                <img style={{width:`24px`,height:`24px`}} src="/update.svg" alt="Update"  onClick={() => handleReload()} className='update-icon'/>
                      <p className='update_time'>Last Updated: {moment().format('DD MMM YYYY hh:mm A')}</p>
                    </div>
                 </div>

              </div>
              
              <div className='view-section-sidebar'>
                {
                  osiComponentItems.map((osiComponentItem, index) => (
                    <div key={index} className={activeIndex === index ? 'active-text' : 'inactive-text'} onClick={() => handleClick(index)}>
                      <p>{osiComponentItem}</p>
                    </div>
                  ))
                } 
              </div>

              <div className='scroll-component' >
                    <div className='osi-reports-div'> 
                      <p className='osi-reports'> Patient Reports {`>`} {data?.patient_name} ({displayPatientIdentifier}) {`>`}</p>
                      <p className='osi-name'> {activeOSIComponentName}</p>
                    </div>
                  <ActiveOSIComponents patientID={patientID}/>
              </div>
              
            </div>

          :  accountType && accountType.length > 0 && accountType === 'Basic' ?

                <div className='view-section'>

                  <div className='basic-view-header'>
                    
                    <div className='left-header-section'>
                      <img className = 'back-arrow' src= "/back_arrow.svg" alt='Back Arrow' onClick = {() => handleClose()} />
                      <p className='basic-reports-text'>Patient Reports {`>`} <span className='patient-text'> {data?.patient_name} ({displayPatientIdentifier})</span> </p>
                    </div>

                    <div className='right-header-section'>
                          <img style={{width:`20px`,height:`20px`, marginLeft: `30px`}} src="/update.svg " alt="Update" onClick={() => handleReload()} className='update-icon'/>
                          <p className='update_time'>Last Updated: {moment().format('DD MMM YYYY hh:mm A')}</p>
                    </div>

                  </div>
                  
                  <div className='view-sidebar-basic'>
                    {
                      basicComponentItems.map((basicComponentItem, index) => (
                        <div>
                          <div key={index} className={activeIndex === index ? 'active-text-basic' : 'inactive-text-basic'} onClick={() => handleClick(index)}>
                            <img src={activeIndex === index ? (basicComponentItem.active_image) : (basicComponentItem.inactive_image)} alt='Text Icon' className='nav-icon'/>
                            <span className='nav-text'>{basicComponentItem.text}</span>
                          </div>
                          {
                            activeIndex === index && basicComponentItem.text === 'Device Data' && 
                              (
                                <div className='side-tab'>
                                  {/* <div  className='sub-tabs'>
                                      <div className={`sub-tab ${selectedSubTab === 'NST' ? 'active-device-text' : 'inactive-device-text'}`} onClick={() => handleSubTabSelection('NST')}> NST</div>
                                      {/* <div className={`sub-tab ${selectedSubTab === 'Recordings' ? 'active-device-text' : 'inactive-device-text'}`} onClick={() => handleSubTabSelection('Recordings')} > Recordings</div> */}
                                  {/* </div> */} 
                          
                                  {mergedDeviceData.length > 0 && (
                                    mergedDeviceData.map((data, index) => (
                                      (data.device_name === 'Keyar DT' ||  data.device_name === 'Keyar CM') && (
                                        <div key={index} className={`timestamp-div ${activeTabIndex === index ? 'active-timestamp' : 'inactive-timestamp'}`} onClick={() => { showGraph(index, data) }}>
                                          <img src={activeTabIndex === index ? data.active_image : data.inactive_image} alt={data.device_name} />
                                          <p>{getReadableTime(data.data_time)}</p>
                                        </div>
                                      )
                                    ))
                                  )}
                          
                                  {/* {selectedSubTab === 'Recordings' && mergedDeviceData.length > 0 && (
                                    mergedDeviceData.map((data, index) => (
                                      ( data.device_name === 'Keyar Echo' && (
                                        <div key={index} className={`timestamp-div ${activeTabIndex=== index ? 'active-timestamp' : 'inactive-timestamp'}`} onClick={() => { showGraph(index, data)}}>
                                          <img src={activeTabIndex === index ? data.active_image : data.inactive_image} alt={data.device_name} />
                                          <p>{getReadableTime(data.data_time)}</p>
                                        </div>
                                      ))
                                    ))
                                  )} */}
                        
                                </div>
                              )
                          }
                        </div>
                      ))
                      
                    } 

                  </div>

                  <div className='scroll-component' >
                    { 
                      ActiveBasicComponents === PatientInformaton ? <PatientInformaton patientID={patientID}/> 
                    :
                      loading ? (
                        <div className='loading-div'><Loading/></div>
                      ) : (
                        deviceData && ActiveBasicComponents === DeviceInformation ? 
                          (
                            <DeviceInformation selectedSubTab ={selectedSubTab} patientID={patientID} data={deviceData.data} basicDetail={basicDetail} numberOfFetus={numberOfFetus}
                            otherDetail={otherDetail} placeDetail={placeDetail} deviceName={deviceData.device_name} isPlaying={isPlaying} setIsPlaying={setIsPlaying} isTabularViewEnabled={isTabularViewEnabled}/>
                          )
                        :
                          <div style={{paddingTop:`60px`, paddingLeft:`26%`}} ><NoData/></div>
                      )
                  }
                    
                  </div>
                
                </div>

           : accountType && accountType.length > 0 && accountType === 'Navam' ?

                <div className='view-section'>

                  <div className='basic-view-header'>
                    
                    <div className='left-header-section'>
                      <img className = 'back-arrow' src= "/back_arrow.svg" alt='Back Arrow' onClick = {() => handleClose()} />
                      <p className='basic-reports-text'>Patient Reports {`>`} <span className='patient-text'> {data?.patient_name} ({displayPatientIdentifier})</span> </p>
                    </div>

                    <div className='right-header-section'>
                          <img style={{ marginLeft: `30px`}} src="/update.svg " alt="update" onClick={() => handleReload()} width={20} height={30} />
                          <p className='update_time'>Last Updated: {moment().format('DD MMM YYYY hh:mm A')}</p>
                    </div>

                  </div>
                  
                  <div className='view-sidebar-basic'>
                    {
                      navamComponentItems.map((navamComponentItem, index) => (
                        <div>
                          <div key={index} className={activeIndex === index ? 'active-text-basic' : 'inactive-text-basic'} onClick={() => handleClick(index)}>
                            <img src={activeIndex === index ? (navamComponentItem.active_image) : (navamComponentItem.inactive_image)} alt='Text Icon' className='nav-icon'/>
                            <span className='nav-text'>{navamComponentItem.text}</span>
                          </div>
                        
                        </div>
                      ))
                      
                    } 

                  </div>

                  <div className='scroll-component'>
                  
                      <div className='reports-div'> 
                        <p className='reports'> Patient Reports{`>`} {data?.patient_name} ({displayPatientIdentifier}) {`>` }</p>
                        <p className='name'> {ActiveNavamComponentName.text}</p>
                      </div>

                      <ActiveNavamComponent patientID={patientID}/>
                      
                  </div>
            
                </div>
          
          : caseSheetOpen && accountType && accountType.length > 0 && accountType !== 'Basic' ? 
            // (  casesheetTab === 'l1-casesheet' ? 
            //     <L1CasesheetLayout patientID={patientID} caseSheetOpen={caseSheetOpen} setCaseSheetOpen= {setCaseSheetOpen} />
            //   :
            //   casesheetTab === 'l2-casesheet' ?
            //     <L2CasesheetLayout patientID={patientID} caseSheetOpen={caseSheetOpen} setCaseSheetOpen= {setCaseSheetOpen} />
            //   : 
            //   casesheetTab === 'l3-casesheet' ?
            //     <L3CasesheetLayout patientID={patientID} caseSheetOpen={caseSheetOpen} setCaseSheetOpen= {setCaseSheetOpen} />
            //   : null
            // )
              <div style={{ height: '100vh', overflowY: 'auto' }}>
                <CaseSheetLayout patientID={patientID} caseSheetOpen={caseSheetOpen} setCaseSheetOpen= {setCaseSheetOpen}/>
              </div>
          :

          // For accountType = 'Premuim';
            <div className='view-section'>
              <div className='view-file-header'>
                  
                    <div className='patient-info-header'>
                        <img className = "back-arrow" src= "/back_arrow.svg" alt='Back Arrow' onClick = {() => handleClose()} />
                        <div className='update'>
                          <img style={{width:`20px`,height:`20px`, marginLeft: `30px`, cursor:`pointer`}} src="/update.svg " alt="update" onClick={() => handleReload()} className='update-icon'/>
                          <p className='update_time'>Last Updated: {moment().format('DD MMM YYYY hh:mm A')}</p>
                        </div>
                    </div>

                    {/* <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectType}
                      label="Tab"
                      onChange={handleChange}
                    >
                      <MenuItem value={'mother'}>Mother</MenuItem>
                    </Select> */}
                    <div style={{display:`flex`,gap:`1.5rem`, marginRight:`3rem`, alignItems:`center`, justifyContent:`center`}}>
                      {/* <Select labelId="demo-simple-select-label" id="demo-simple-select"
                          sx={{
                            width: '50%',
                            borderRadius: '100px',
                            border: '0.5px solid #A163F1',
                            height: '3.125rem',
                            background: '#F8F5FF',
                            fontFamily: 'Poppins',
                            '&:hover': { border: 'transparent' },
                            '& .MuiSelect-select': {
                              color: '#A163F1',
                              fontSize: '1rem',
                              fontWeight: '400',
                              mt: '5px',
                              ml: '10px',
                            },
                          }} 
                          value={casesheetTab}
                          onChange={handleTabChange}
                          >
                          {
                            Object.entries(casesheets).map(([key, value]) => (
                              <StyledMenuItem key={value} value={value}> {key} </StyledMenuItem>
                            ))
                          }
                      </Select> */}
                      <button className="casesheet-button" onClick={openCaseSheet}> View Case Sheet </button>
                    </div>

              </div>
              
              <div className='view-section-sidebar'>
                  {
                    componentItems.map((componentItem, index) => (
                      <div key={index} className={activeIndex === index ? 'active-text' : 'inactive-text'} onClick={() => handleClick(index)}>
                        <p>{componentItem}</p>
                      </div>
                    ))
                  }
                  
                  <hr className='horizontal-line'/>

                  <div className='viewfile-footer'>
                    <img src="/janitri-registered-logo.svg"  alt="Janitri Logo" className='janitri-logo'/>
                    {/* <p className='date-footer'>{moment().format('DD/MM/YYYY hh:mm A')}</p> */}
                  </div>
                  
              </div>
              
              <div className='scroll-component'>
                
                  <div className='reports-div'> 
                    <p className='reports'>Patient Reports {`>`} {data?.patient_name} ({displayPatientIdentifier}) {`>` }</p>
                    <p className='name'> { data?.alerts ? 'Alerts' : activeComponentName}</p>
                  </div>

                  <ActiveComponent patientID={patientID}/>
                  
              </div>

            </div> 
      }

    </div>
  </div>
  )
}

export default ViewLayout;

